/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ScheduledAssessmentProposalConflictsResponse model module.
 * @module model/ScheduledAssessmentProposalConflictsResponse
 * @version 1.0.0
 */
class ScheduledAssessmentProposalConflictsResponse {
    /**
     * Constructs a new <code>ScheduledAssessmentProposalConflictsResponse</code>.
     * @alias module:model/ScheduledAssessmentProposalConflictsResponse
     */
    constructor() { 
        
        ScheduledAssessmentProposalConflictsResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduledAssessmentProposalConflictsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduledAssessmentProposalConflictsResponse} obj Optional instance to populate.
     * @return {module:model/ScheduledAssessmentProposalConflictsResponse} The populated <code>ScheduledAssessmentProposalConflictsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduledAssessmentProposalConflictsResponse();

            if (data.hasOwnProperty('conflict_property_count')) {
                obj['conflict_property_count'] = ApiClient.convertToType(data['conflict_property_count'], 'Number');
            }
            if (data.hasOwnProperty('conflict_property_ids')) {
                obj['conflict_property_ids'] = ApiClient.convertToType(data['conflict_property_ids'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScheduledAssessmentProposalConflictsResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScheduledAssessmentProposalConflictsResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['conflict_property_ids'])) {
            throw new Error("Expected the field `conflict_property_ids` to be an array in the JSON data but got " + data['conflict_property_ids']);
        }

        return true;
    }


}



/**
 * 同じ暦日に送信予約が入っている物件数
 * @member {Number} conflict_property_count
 */
ScheduledAssessmentProposalConflictsResponse.prototype['conflict_property_count'] = undefined;

/**
 * 同じ暦日に送信予約が入っている物件 ID
 * @member {Array.<Number>} conflict_property_ids
 */
ScheduledAssessmentProposalConflictsResponse.prototype['conflict_property_ids'] = undefined;






export default ScheduledAssessmentProposalConflictsResponse;

